import lang from '@/lang'
import config from '@/modules/banking/config'
import { FINANCE_API } from '@/modules/banking/constants'
import request from '@/modules/base/util/request'
import WebStorageService from '@/modules/_services/webstorage.service'
import { toast } from '@/modules/base/components/toast/toastConfig'
import { ACTION_PREFIX_BANK_ACCOUNT_LIST as ACTION_PREFIX } from '@/redux/ducks/constants'
import { uniq } from 'lodash'
import { setShallRefresh, LIST_TYPES } from '@/redux/ducks/lists'

const { urls } = config
const { CONTACT_TYPE, CONTACT_SETUP_REQUIRED_STATE, ACCOUNT_TYPE: { OFFLINE_ACCOUNT } } = FINANCE_API

const { BANKING_LIST_TYPE } = LIST_TYPES

const fetchGetDefault = (url) => {
  return request(url, {
    auth: true,
    isConcurrent: true,
  })
}
// actions
const SET_BANK_ACCOUNTS = `${ACTION_PREFIX}/setBankAccounts`
const SET_BANK_ACCOUNT_ALL_ACCOUNT_BALANCE = `${ACTION_PREFIX}/setBankAccountAllAccountBalance`
const SELECT_BANK_ACCOUNT = `${ACTION_PREFIX}/selectBankAccount`
const FETCHING_BANK_ACCOUNTS = `${ACTION_PREFIX}/fetchingBankAccounts`
const SHOW_CONTEXT_MENU = `${ACTION_PREFIX}/showContextMenu`
const HIDE_CONTEXT_MENU = `${ACTION_PREFIX}/hideContextMenu`
const OPEN_BANK_ACCOUNT_EDIT_MODAL = `${ACTION_PREFIX}/openBankAccountEditModal`
const CLOSE_BANK_ACCOUNT_EDIT_MODAL = `${ACTION_PREFIX}/closeBankAccountEditModal`
const OPEN_BANK_ACCOUNT_ADD_MODAL = `${ACTION_PREFIX}/openBankAccountAddModal`
const CLOSE_BANK_ACCOUNT_ADD_MODAL = `${ACTION_PREFIX}/closeBankAccountAddModal`
const CLOSE_BANK_ACCOUNT_INFO_MODAL = `${ACTION_PREFIX}/closeBankAccountTeaserModal`
const TOGGLE_BANK_ACCOUNT_LIST = `${ACTION_PREFIX}/toggleBankAccountList`
const TOGGLE_SHOW_BANK_ACCOUNTS = `${ACTION_PREFIX}/toggleShowBankAccounts`
const RESET_STATE = `${ACTION_PREFIX}/resetState`
const VISIBLE_BANKACCOUNTS_ENTRY = 'visibleBankAccounts'
const LOCAL_STORE_ENTRY = `${ACTION_PREFIX}`

// bank account storage helpers
const readFromLocalStoreVisibleAccounts = () => {
  try {
    const bankAccountsVisibleFromStorage = WebStorageService.getItem(`${LOCAL_STORE_ENTRY}/${VISIBLE_BANKACCOUNTS_ENTRY}`)
    return bankAccountsVisibleFromStorage || []
  } catch {
    return []
  }
}

const saveToLocalStore = (bankAccountsVisible) => {
  try {
    WebStorageService.setItem(`${LOCAL_STORE_ENTRY}/${VISIBLE_BANKACCOUNTS_ENTRY}`, bankAccountsVisible)
  } catch (error) {}
}

// reducer
const initialState = () => ({
  selectedBankAccount: null,
  bankAccountListOpen: true,
  bankAccountAll: {
    id: 'all',
    accountName: 'Alle Konten',
    accountType: 'all',
    bankLogoLarge: '/images/banklogos/large/default.png',
    bankLogoSmall: '/images/banklogos/small/default.png',
    accountBalance: 0,
    accountCurrency: 'eur',
    autoSyncBookingsStatus: 'disabled',
  },
  bankAccounts: [],
  contextMenu: null,
  isLoading: false,
  isInitialLoading: true,
  showBankAccountEditModal: false,
  showBankAccountAddModal: false,
  showTeaser: true,
  bankAccountsVisible: readFromLocalStoreVisibleAccounts(),
})

export default function reducer(state = initialState(), action) {
  switch (action.type) {
    case FETCHING_BANK_ACCOUNTS: {
      return {
        ...state,
        isLoading: true,
      }
    }
    case SELECT_BANK_ACCOUNT: {
      const { selectedBankAccount } = action
      return {
        ...state,
        selectedBankAccount,
      }
    }
    case SET_BANK_ACCOUNTS: {
      const { bankAccounts } = action

      const { bankAccountsVisible } = state

      const newBankAccountsVisible = bankAccounts?.map((account) => {
        const { accountName, id } = account
        const isChecked = bankAccountsVisible.find(item => item.id === id)?.checked

        return {
          accountName,
          id,
          checked: !(isChecked === false),
        }
      })

      return {
        ...state,
        bankAccounts,
        bankAccountsVisible: newBankAccountsVisible,
        isLoading: false,
        isInitialLoading: false,
      }
    }
    case SET_BANK_ACCOUNT_ALL_ACCOUNT_BALANCE: {
      const { accountBalance } = action
      return {
        ...state,
        bankAccountAll: {
          ...state.bankAccountAll,
          accountBalance,
        },
        isLoading: false,
      }
    }
    case SHOW_CONTEXT_MENU: {
      const { contextMenu } = action
      return {
        ...state,
        contextMenu,
      }
    }
    case HIDE_CONTEXT_MENU: {
      return {
        ...state,
        contextMenu: null,
      }
    }
    case OPEN_BANK_ACCOUNT_EDIT_MODAL:
      return {
        ...state,
        showBankAccountEditModal: true,
      }
    case CLOSE_BANK_ACCOUNT_EDIT_MODAL:
      return {
        ...state,
        showBankAccountEditModal: false,
      }
    case OPEN_BANK_ACCOUNT_ADD_MODAL:
      return {
        ...state,
        showBankAccountAddModal: true,
        showTeaser: false,
      }
    case CLOSE_BANK_ACCOUNT_ADD_MODAL:
      return {
        ...state,
        showBankAccountAddModal: false,
      }
    case CLOSE_BANK_ACCOUNT_INFO_MODAL:
      return {
        ...state,
        showTeaser: false,
      }
    case TOGGLE_BANK_ACCOUNT_LIST:
      const { bankAccountListOpen } = action
      return {
        ...state,
        bankAccountListOpen,
      }
    case TOGGLE_SHOW_BANK_ACCOUNTS:
      const { bankAccountsVisible } = action

      saveToLocalStore(bankAccountsVisible)

      return {
        ...state,
        bankAccountsVisible,
      }
    case RESET_STATE: {
      return initialState()
    }
    default:
      return state
  }
}

// action creators
export const selectBankAccount = (bankAccount) => ({ type: SELECT_BANK_ACCOUNT, selectedBankAccount: bankAccount })
export const fetchingBankAccounts = () => ({ type: FETCHING_BANK_ACCOUNTS })
export const setBankAccounts = (bankAccounts) => ({ type: SET_BANK_ACCOUNTS, bankAccounts })
export const setBankAccountAllAccountBalance = (accountBalance) => ({ type: SET_BANK_ACCOUNT_ALL_ACCOUNT_BALANCE, accountBalance })
export const openContextMenu = (target, accountData) => ({
  type: SHOW_CONTEXT_MENU,
  contextMenu: { target, accountData },
})
export const hideContextMenu = () => ({ type: HIDE_CONTEXT_MENU })
export const openBankAccountEditModal = () => ({ type: OPEN_BANK_ACCOUNT_EDIT_MODAL })
export const closeBankAccountEditModal = () => ({ type: CLOSE_BANK_ACCOUNT_EDIT_MODAL })
export const openBankAccountAddModal = () => ({ type: OPEN_BANK_ACCOUNT_ADD_MODAL })
export const closeBankAccountAddModal = () => ({ type: CLOSE_BANK_ACCOUNT_ADD_MODAL })
export const closeBankAccountInfoModal = () => ({ type: CLOSE_BANK_ACCOUNT_INFO_MODAL })
export const toggleBankAccountList = (bankAccountListOpen) => ({ type: TOGGLE_BANK_ACCOUNT_LIST, bankAccountListOpen })
export const toggleShowBankAccounts = (bankAccountsVisible) => ({ type: TOGGLE_SHOW_BANK_ACCOUNTS, bankAccountsVisible })
export const resetState = () => ({ type: RESET_STATE })

export const updateBankAccount = (data, bankAccountInfo) => {
  return (dispatch, getState) => {
    request(urls.updateBankAccount, {
      auth: true,
      method: 'PUT',
      data,
    })
      .then((response) => {
        const { body: { data: updatedBankAccount } } = response

        const { banking: { bankAccountList: { bankAccounts, selectedBankAccount } } } = getState()
        const updatedBankAccountIndex = bankAccounts.findIndex((bankAccount) => {
          return bankAccount.id === updatedBankAccount.id
        })
        if (updatedBankAccountIndex < 0) {
          throw new Error('BankAccount not found.')
        }
        const newBankAccounts = [...bankAccounts]
        newBankAccounts.splice(updatedBankAccountIndex, 1, updatedBankAccount)
        dispatch(setBankAccounts(newBankAccounts))

        // update if bank account was selected before
        if (selectedBankAccount.id === updatedBankAccount.id) {
          dispatch(selectBankAccount(updatedBankAccount))
        }
        toast.showToast({ message: lang.bankingUpdateBankAccountSuccessMessage, bankAccountInfo: updatedBankAccount })
      })
      .catch(error => toast.showToast({ bankAccountInfo, error, message: lang.bankingUpdateBankAccountErrorMessage }))
  }
}

export const deleteBankAccount = (bankAccountId, bankAccountInfo) => {
  return (dispatch) => {
    const ur = urls.deleteBankAccount(bankAccountId)
    request(urls.deleteBankAccount(bankAccountId), {
      auth: true,
      method: 'DELETE',
    })
      .then(() => {
        dispatch(fetchBankAccountList())
        dispatch(setShallRefresh(BANKING_LIST_TYPE, true))
        toast.showToast({ message: lang.bankingDeleteBankAccountSuccessMessage, bankAccountInfo })
      })
      .catch(error => toast.showToast({ error, bankAccountInfo, message: lang.bankingDeleteBankAccountErrorMessage }))
  }
}

export const destructListResponse = (response) => {
  return new Promise((resolve) => {
    const { body } = response
    const { data } = body
    resolve(data)
  })
}

export const handleBankAccountList = (dispatch) => {
  return (bankAccounts) => {
    dispatch(setBankAccounts(bankAccounts))
    return bankAccounts
  }
}

export const reduceToResource = async(response) => {
  const { body } = response
  const { data } = body
  return data
}

export const fetchBankAccountStatus = (bankAccountList) => {
  bankAccountList
    .forEach((bankAccount) => {
      bankAccount.accessTypeUpdatePossible = false
      bankAccount.accessTypeUpdateMandatory = false
      bankAccount.accessTypeChanged = false
    })

  const uniqContactIds = uniq(bankAccountList
    .filter(bankAccount => bankAccount.contactType === CONTACT_TYPE.BANK && !bankAccount.ignoreContactSetupRequired)
    .map(ba => ba.contactId),
  )
  const fetchStatusCalls = uniqContactIds.map(contactId => new Promise((resolve, reject) => {
    fetchGetDefault(urls.fetchSetupRequiredForAccount({ contactId }))
      .then(reduceToResource)
      .then((accountStatus) => {
        resolve({ ...accountStatus, contactId })
      })
      .catch((error) => {
        toast.showToast({ bankAccountInfo: bankAccountList.find(ba => ba.contactId === contactId), error })
        resolve({})
      })
  }))

  const setBankAccounts = (statusResults) => {
    return bankAccountList
      .filter(bankAccount => bankAccount.contactType === CONTACT_TYPE.BANK)
      .map(bankAccount => {
        const accountStatus = statusResults.find(c => c.contactId === bankAccount.contactId)
        if (accountStatus) {
          bankAccount.accessTypeUpdatePossible = accountStatus.contactSetupRequiredState === CONTACT_SETUP_REQUIRED_STATE.CONTACT_SETUP_POSSIBLE
          bankAccount.accessTypeUpdateMandatory = accountStatus.contactSetupRequiredState === CONTACT_SETUP_REQUIRED_STATE.CONTACT_SETUP_MANDATORY
          bankAccount.accessTypeChanged = accountStatus.contactSetupRequiredState !== CONTACT_SETUP_REQUIRED_STATE.NO_ACTION_NECESSARY
        }
        return bankAccount
      })
  }

  return new Promise((resolve, reject) => {
    Promise
      .all(fetchStatusCalls)
      .then(setBankAccounts)
      .then(() => {
        resolve(bankAccountList)
      })
      .catch(errors => {
        reject(bankAccountList)
      })

  })
}

export const fetchBankAccountList = () => {
  return (dispatch) => {
    dispatch(fetchingBankAccounts())
    return fetchGetDefault(urls.fetchBankAccountList)
      .then(destructListResponse)
      .then(fetchBankAccountStatus)
      .then(handleBankAccountList(dispatch))
      .catch((bankAccounts) => {
        toast.showToast({ type: 'error', message: lang.bankingFetchBankAccountErrorMessage })
        handleBankAccountList(dispatch)(bankAccounts)
      })
  }
}

export const isMovementSupported = (bankAccountInfo) => {
  return new Promise((resolve, reject) => {
    if ([CONTACT_TYPE.KLARNA, CONTACT_TYPE.SHOPIFY_PAYMENTS, CONTACT_TYPE.STRIPE].includes(bankAccountInfo.contactType)) resolve(true)
    if (bankAccountInfo.contactType === CONTACT_TYPE.BANK) {
      return fetchGetDefault(urls.getBankContactAccountDetails(bankAccountInfo.id))
        .then(({ body: { data: { supportedTransactions } } }) => {
          resolve(supportedTransactions.some((transaction) => transaction.transactionType === 'movement'))
        })
        .catch((error) => {
          toast.showToast({ error, bankAccountInfo })
          reject(error)
        })
    } else {
      resolve(false)
    }
  })
}
